import { postApiVolumeTableExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityApiVolumeTableExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityApiVolumeTableExport',
	receive: true,
	request: true,
	requestHandler: postApiVolumeTableExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
